import ResponsiveImage from "./ResponsiveImage";

const setInnerHTML = (content) => {
  return { __html: content };
};

const HomeTile = ({
  index,
  specialClassName,
  header,
  subheader,
  content,
  customClassName,
  imageAlternativeText,
  imageFile,
  linkURL,
  linkTitle,
  openInNewWindow,
}) => {
  return (
    <div
      className={specialClassName ? "tile " + specialClassName : "tile"}
      key={index}
    >
      <div className="tileHeader">
        <h3>
          <span>{header}</span>
        </h3>
      </div>
      <div className="tileInside">
        <h4>{subheader}</h4>
        <div className="tileBody">
          {content.map((contentItem, idx) => (
            <p
              key={index + "." + idx}
              dangerouslySetInnerHTML={setInnerHTML(contentItem)}
            />
          ))}
        </div>
      </div>
      <div className="tileBottom">
        <ResponsiveImage
          customClassName={customClassName || "tileImage"}
          alt={imageAlternativeText}
          publicURL={process.env.PUBLIC_URL}
          fileName={imageFile}
          linkURL={linkURL}
          linkTitle={linkTitle}
          openInNewWindow={openInNewWindow}
        />
      </div>
    </div>
  );
};

export default HomeTile;
